import { BillsToPayList } from './pages/billsToPayList';

export const BillsToPayRoutes = [
  {
    path: '/financeiro/contas-a-pagar',
    exact: true,
    component: BillsToPayList,
  },
];
